import { useCallback } from 'react';
import config from '../../config/config';
import Decimal from 'decimal.js';

const useApproveEvent = () => {
  const approveEvent = useCallback(
    async (tokenType, recipientAddress, value) => {
      console.log({ tokenType, recipientAddress, value });

      let transactionData;

      if (tokenType === 'HVH') {
        console.log(`${tokenType} 전송`);

        const tokenValue = parseFloat(value);

        transactionData = {
          to: recipientAddress, // 받는 사람의 지갑 주소
          value: tokenValue, // 전송할 HVH 액수 HVH는 있는 그대로 전송 해야함
        };
      } else {
        console.log(`${tokenType} 전송`);

        const tokenAddress =
          /XPER/i.test(tokenType) || /ADDXPER/i.test(tokenType) // 예산 추가 반영
            ? config.TOKEN_CONTRACT_ADDRESS.xper
            : config.TOKEN_CONTRACT_ADDRESS.per;

        const tokenValue = new Decimal(value);

        transactionData = {
          to: tokenAddress, // 토큰주소(컨트렉트 주소 (XPER, PER))
          method: 'transfer',
          params: {
            _to: recipientAddress, // 서버가 보내준 지갑주소
            _value: tokenValue.toHex(), // 설정한 액수(예산)
          },
        };
      }

      console.log('transactionData: ', transactionData);

      // 승인 버튼 누르면 아래 실행
      let transactionResult = false;
      let txHash = null;
      let res = null;
      try {
        res = await window.havah.sendTransaction(transactionData);
        console.log('res: ', res);

        const type = res.type;

        if (type === 'success') {
          transactionResult = true;
          txHash = res.txHash;
        }

        if (type !== 'success') {
          throw new Error(`${res}`);
        }

        // throw Error(`${res}`);
      } catch (error) {
        console.error('에러:', error);
        console.error(`Error: ${error}`);
      }

      return { txHash, transactionResult, res };
    },
    [],
  );

  return approveEvent;
};

export default useApproveEvent;
